export const isServiceWorker = typeof window === 'undefined'
export const isCypress = !isServiceWorker && 'Cypress' in window
